import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD6mhbs0Qx6e_PwXPkuSUWUP-9vcGy2-Y4",
  authDomain: "contact-d435a.firebaseapp.com",
  projectId: "contact-d435a",
  storageBucket: "contact-d435a.appspot.com",
  messagingSenderId: "1086384587684",
  appId: "1:1086384587684:web:196b25adf0882bf7857731",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore();
